import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/** The value when it is a non-empty string, else `null`. */
export const asString = (value: unknown): string | null =>
  typeof value === "string" && value !== "" ? value : null;

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
